import React from 'react'
import HeaderTwo from '../../../components/header/HeaderTwo';
import Footer from '../../../components/footer/Footer';
import ReleaseGame from './ReleaseGame'
import SingleArea from './SingleArea';
import Breadcrumb from './breadcuumb';

function GameSingle() {
  return (
	<>
	<HeaderTwo/>
	<main>
	{/* <Breadcrumb/> */}
	<SingleArea/>
	</main>
	<Footer/>
	</>
  )
}

export default GameSingle